function r(e) {
  const n = { className: "attr", begin: /"(\\.|[^\\"\r\n])*"(?=\s*:)/, relevance: 1.01 }, l = { match: /[{}[\],:]/, className: "punctuation", relevance: 0 }, a = ["true", "false", "null"], t = { scope: "literal", beginKeywords: a.join(" ") };
  return { name: "JSON", keywords: { literal: a }, contains: [n, l, e.QUOTE_STRING_MODE, t, e.C_NUMBER_MODE, e.C_LINE_COMMENT_MODE, e.C_BLOCK_COMMENT_MODE], illegal: "\\S" };
}
export {
  r as default
};
